export default "__VITE_ASSET__60c3b57b__"